import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dialog, DialogBody, Tab, Tabs } from '@blueprintjs/core';
import { Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import getAtomsFromMF from '../../../data/utilities/getAtomsFromMF';
import { useChartData } from '../../context/ChartContext';
import { useDispatch } from '../../context/DispatchContext';
import Button from '../../elements/Button';
import MoleculeSelection from '../../elements/MoleculeSelection';
import FormikError from '../../elements/formik/FormikError';
import FormikInput from '../../elements/formik/FormikInput';
function isValidMf(value) {
    try {
        getAtomsFromMF(value);
        return true;
    }
    catch {
        return false;
    }
}
const validationSchema = Yup.object({
    mf: Yup.string()
        .required()
        .test('valid-mf', 'Enter a valid molecular formula', (value) => isValidMf(value)),
});
const styles = {
    input: {
        padding: '0.5rem',
    },
    container: {
        padding: '0.5rem',
    },
    error: {
        textAlign: 'center',
        color: 'red',
        fontSize: '0.9em',
    },
    title: {
        textAlign: 'center',
    },
};
export function SetMolecularFormulaModal(props) {
    const { isOpen, ...otherProps } = props;
    if (!isOpen) {
        return;
    }
    return _jsx(InnerSetMolecularFormulaModal, { ...otherProps });
}
function InnerSetMolecularFormulaModal({ onClose, }) {
    const dispatch = useDispatch();
    function saveHandler(mf) {
        dispatch({
            type: 'SET_CORRELATIONS_MF',
            payload: {
                mf,
            },
        });
        onClose?.();
    }
    return (_jsx(Dialog, { isOpen: true, title: "Molecular formula", style: { width: 400 }, onClose: onClose, children: _jsx(DialogBody, { children: _jsxs(Tabs, { fill: true, children: [_jsx(Tab, { id: "manual", title: "Manual", panel: _jsx(ManualFormula, { onSave: saveHandler }) }), _jsx(Tab, { id: "auto", title: "Auto", panel: _jsx(AutoFormula, { onSave: saveHandler }) })] }) }) }));
}
function ManualFormula(props) {
    const { correlations } = useChartData();
    function saveHandler(data) {
        props?.onSave(data.mf);
    }
    return (_jsxs("div", { style: styles.container, children: [_jsx("p", { children: "Please type in a molecular formula!" }), _jsx(Formik, { onSubmit: saveHandler, initialValues: { mf: correlations?.options?.mf }, validationSchema: validationSchema, children: ({ isValid, handleSubmit }) => (_jsxs(_Fragment, { children: [_jsx(FormikError, { name: "mf", children: _jsx(FormikInput, { name: "mf", placeholder: "Enter a molecular formula", style: { input: styles.input }, checkErrorAfterInputTouched: false }) }), _jsx(Button.Done, { onClick: () => handleSubmit(), disabled: !isValid, style: { marginTop: '10px' }, children: "Set molecular formula" })] })) })] }));
}
function AutoFormula(props) {
    const { molecules } = useChartData();
    const [currentIndex, setCurrentIndex] = useState(0);
    function onChangeHandlerMoleculeSelection(index) {
        setCurrentIndex(index);
    }
    function saveHandler() {
        const mf = molecules?.[currentIndex]?.mf;
        props?.onSave(mf);
    }
    if (!molecules || molecules?.length === 0) {
        return (_jsx("p", { style: styles.error, children: "You have to Select a spectrum and Add a molecule from the Structure panel to select as a reference!" }));
    }
    return (_jsxs("div", { style: styles.container, children: [_jsx("p", { style: styles.title, children: "Select a molecule as reference!" }), _jsx(MoleculeSelection, { molecules: molecules, onChange: onChangeHandlerMoleculeSelection }), _jsx(Button.Done, { onClick: saveHandler, disabled: !molecules?.[currentIndex], style: { marginTop: '10px' }, children: "Set molecular formula" })] }));
}
